module.exports = __webpack_public_path__ + "img/licence1-1.26b28007.jpg";